import { setState } from '@/commonTypes';
import Filters from '@/components/general/Filters';
import { useSearchParams } from 'next/navigation';
import React, { ReactNode } from 'react';

export default function SearchFilters({
  children,
  className = '',
}: {
  children?: ReactNode;
  className?: string;
}) {
  const searchParams = useSearchParams();
  return (
    <div className={`card ${className}`}>
      {children}
      <Filters
        // setPageNumber={setPageNumber}
        sortParams={{
          sort: searchParams?.get('sort'),
          orderBy: searchParams?.get('orderBy'),
        }}
      />
    </div>
  );
}
